export const JOB_TYPES = [
  { name: 'Book Builder', value: 'CG', disabled: false },
  { name: 'Case Builder', value: 'CB', disabled: true },
  { name: 'Question Bank', value: 'QB', disabled: true },
];
